(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-announcement-form]');
  if (!trigger) return;
  const formId = trigger.dataset.announcementForm.trim();
  if (!formId) return;
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-contact-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('care-contact-form')) customElements.define('care-contact-form', class extends HTMLElement {
    connectedCallback() {
      if (!this.isConnected) return;
      if (document.readyState === 'loading') {
        this.ready ||= () => this.connectedCallback();
        document.addEventListener('DOMContentLoaded', this.ready, {once:true});
        return;
      }
      this.mount = this.querySelector('.care-form__mount');
      this.loading = this.querySelector('.care-form__loading');
      this.error = this.querySelector('.care-form__error');
      this.retry = this.querySelector('[data-retry]');
      this.onRetry = () => { this.mount.replaceChildren(); this.start(); };
      this.retry.addEventListener('click', this.onRetry);
      if (this.mount.querySelector('iframe')) return;
      if ('IntersectionObserver' in window) {
        this.near = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { this.near.disconnect(); this.start(); } }, {rootMargin:'600px 0px'});
        this.near.observe(this);
      } else this.start();
    }
    start() {
      if (!this.isConnected || this.mount.querySelector('script')) return;
      this.error.hidden = true;
      this.mount.hidden = false;
      this.loading.hidden = false;
      this.setAttribute('data-loading', '');
      const finish = () => { clearTimeout(this.timer); this.loading.hidden = true; this.removeAttribute('data-loading'); };
      const failed = () => { finish(); this.mount.hidden = true; this.error.hidden = false; };
      this.frames?.disconnect();
      this.frames = new MutationObserver(() => {
        const frame = this.mount.querySelector('iframe');
        if (!frame) return;
        frame.title = this.dataset.frameTitle;
        if (!this.frameObserved) { this.frameObserved = frame; frame.addEventListener('load', finish, {once:true}); }
      });
      this.frameObserved = null;
      this.frames.observe(this.mount, {childList:true,subtree:true});
      const script = document.createElement('script');
      script.src = 'https://contact.gorgias.help/api/contact-forms/loader.js?v=3';
      script.defer = true;
      script.dataset.gorgiasLoaderContactForm = '';
      script.dataset.gorgiasContactFormUid = this.dataset.uid;
      script.addEventListener('error', failed, {once:true});
      this.mount.append(script);
      this.timer = setTimeout(() => { if (this.hasAttribute('data-loading')) failed(); }, 15000);
    }
    disconnectedCallback() {
      if (this.ready) document.removeEventListener('DOMContentLoaded', this.ready);
      this.near?.disconnect();
      this.frames?.disconnect();
      clearTimeout(this.timer);
      this.retry?.removeEventListener('click', this.onRetry);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-delivery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('care-destinations')) customElements.define('care-destinations', class extends HTMLElement {
    connectedCallback() {
      if (!this.isConnected) return;
      if (document.readyState === 'loading') {
        this.ready ||= () => this.connectedCallback();
        document.addEventListener('DOMContentLoaded', this.ready, {once:true});
        return;
      }
      this.select = this.querySelector('select');
      this.regions = [...this.querySelectorAll('[data-region]')];
      if (!this.select || !this.regions.length) return;
      this.change = () => this.regions.forEach(region => { region.hidden = region.dataset.region !== this.select.value; });
      this.change();
      this.querySelector('.care-destinations__selector').hidden = this.regions.length < 2;
      this.select.addEventListener('change', this.change);
      if (window.Shopify?.designMode) {
        this.onBlockSelect = event => {
          const region = event.target.closest('[data-region]');
          if (!region || !this.contains(region)) return;
          this.select.value = region.dataset.region;
          this.change();
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
    disconnectedCallback() {
      if (this.ready) document.removeEventListener('DOMContentLoaded', this.ready);
      this.select?.removeEventListener('change', this.change);
      if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-intro"] && !Shopify.designMode) return;
  try {
    
  const updateCollectionIntro = (intro) => {
    const text = intro.querySelector('.collection-intro__text');
    const button = intro.querySelector('.collection-intro__toggle');
    if (!text || !button) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    text.classList.add('is-clamped');
    button.hidden = text.scrollHeight <= text.clientHeight + 1;
    text.classList.toggle('is-clamped', !expanded && !button.hidden);
  };

  const updateCollectionIntros = (root = document) => {
    root.querySelectorAll('.collection-intro').forEach(updateCollectionIntro);
  };

  updateCollectionIntros();
  document.fonts?.ready.then(() => updateCollectionIntros());
  window.addEventListener('resize', () => updateCollectionIntros());
  document.addEventListener('shopify:section:load', (event) => updateCollectionIntros(event.target));
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.collection-intro__toggle');
    if (!button) return;
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Read Less' : 'Read More';
    button.previousElementSibling.classList.toggle('is-clamped', !expanded);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-submenu"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collection-submenu')) {
  customElements.define('collection-submenu', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const list = this.querySelector('.collection-submenu__items');
        if (!list) return;
        const current = new URL(location.href);
        const path = url => url.pathname.replace(/\/$/, '') || '/';
        const links = [...list.querySelectorAll('a')].sort((a, b) => Number(a.dataset.menuIndex) - Number(b.dataset.menuIndex));
        let selected;
        let specificity = -1;
        for (const link of links) {
          const url = new URL(link.href, current);
          const params = [...url.searchParams];
          const matches = url.origin === current.origin && path(url) === path(current) && params.every(([key, value]) => current.searchParams.getAll(key).includes(value));
          if (matches && params.length > specificity) { selected = link; specificity = params.length; }
          link.removeAttribute('aria-current');
        }
        if (selected) selected.setAttribute('aria-current', 'page');
        list.append(...(selected ? [selected, ...links.filter(link => link !== selected)] : links));
      };
      this.update();
      window.addEventListener('popstate', this.update);
      document.addEventListener('collection:url-changed', this.update);
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.update);
      document.removeEventListener('collection:url-changed', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', class extends HTMLElement {
    connectedCallback() {
      window.clearTimeout(this.updateTimeout);
      window.cancelAnimationFrame(this.initialFrame);
      if (this.querySelector('[data-countdown-days]')) this.startCountdown();
      else this.initialFrame = window.requestAnimationFrame(() => this.startCountdown());
    }
    startCountdown() {
      const endTime = Number(this.dataset.countdownEnd) * 1000;
      const outputs = ['days', 'hours', 'minutes'].map(unit => this.querySelector(`[data-countdown-${unit}]`));
      if (!Number.isFinite(endTime) || !outputs.every(Boolean)) return;
      const update = () => {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          this.textContent = this.dataset.expiredText;
          return;
        }
        const totalMinutes = Math.floor(remaining / 60000);
        const values = [Math.floor(totalMinutes / 1440), Math.floor(totalMinutes % 1440 / 60), totalMinutes % 60];
        outputs.forEach((output, index) => { output.textContent = String(values[index]).padStart(2, '0'); });
        this.updateTimeout = window.setTimeout(update, (remaining % 60000 || 60000) + 50);
      };
      update();
    }
    disconnectedCallback() {
      window.cancelAnimationFrame(this.initialFrame);
      window.clearTimeout(this.updateTimeout);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care-navigation"]) return;
  try {
    
  if (!customElements.get('care-navigation')) customElements.define('care-navigation', class extends HTMLElement {
    connectedCallback() {
      if (!this.isConnected) return;
      if (document.readyState === 'loading') {
        this.ready ||= () => this.connectedCallback();
        document.addEventListener('DOMContentLoaded', this.ready, {once:true});
        return;
      }
      this.details = this.querySelector('details');
      if (window.Shopify?.designMode) {
        this.select = () => { this.details.open = true; };
        this.addEventListener('shopify:block:select', this.select);
      }
    }
    disconnectedCallback() {
      if (this.ready) document.removeEventListener('DOMContentLoaded', this.ready);
      if (this.select) this.removeEventListener('shopify:block:select', this.select);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-callouts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-review-callouts')) {
    customElements.define('customer-review-callouts', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }
      initialize() {
        if (this.initialized || this.hasAttribute('editor')) return;
        const grid = this.querySelector('[data-review-grid]');
        if (!grid) return;
        this.initialized = true;
        const cards = Array.from(grid.querySelectorAll('[data-review-card]'));
        if (this.hasAttribute('randomize')) {
          for (let i = cards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [cards[i], cards[j]] = [cards[j], cards[i]];
          }
        }
        const limit = Math.max(1, Number(this.dataset.limit) || 4);
        const fragment = document.createDocumentFragment();
        cards.forEach((card, index) => {
          card.hidden = index >= limit;
          fragment.append(card);
        });
        grid.append(fragment);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-image-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (typeof ManagedHTMLElement === 'undefined' || customElements.get('editorial-banner-video')) return;
      customElements.define('editorial-banner-video', class extends ManagedHTMLElement {
        connectedCallback() {
          this.control = this.querySelector('.editorial-image-banner__playback');
          if (!this.control) { this.requestFrame(() => this.connectedCallback()); return; }
          this.media = this.querySelector('.editorial-image-banner__media');
          this.mobile = matchMedia('(max-width: 1199px)');
          this.motion = matchMedia('(prefers-reduced-motion: reduce)');
          this.visible = false;
          this.control.hidden = false;
          this.listenTo(this.control, 'click', () => {
            this.userPaused = !this.video?.paused && !!this.video;
            this.userStarted = !this.userPaused;
            this.update();
          });
          this.listenTo(this.mobile, 'change', () => this.update());
          this.listenTo(this.motion, 'change', () => { this.userStarted = false; this.update(); });
          this.listenTo(document, 'visibilitychange', () => this.update());
          this.listenTo(this, 'playing', event => {
            if (event.target === this.video) { this.video.dataset.ready = ''; this.updateControl(); }
          }, { capture: true });
          this.listenTo(this, 'pause', () => this.updateControl(), { capture: true });
          this.listenTo(this, 'error', event => {
            if (event.target === this.video) { delete this.video.dataset.ready; this.updateControl(); }
          }, { capture: true });
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries.some(entry => entry.isIntersecting);
            this.update();
          });
          this.observer.observe(this.media);
          this.updateControl();
        }
        update() {
          if (!this.isConnected) return;
          const device = this.mobile.matches && this.querySelector('[data-banner-video="mobile"]') ? 'mobile' : 'desktop';
          if (this.device !== device && this.video) {
            this.video.pause();
            this.video.remove();
            this.video = null;
          }
          if (!this.visible || document.hidden || this.userPaused || this.motion.matches && !this.userStarted) {
            this.video?.pause();
            this.updateControl();
            return;
          }
          if (!this.video) {
            const video = this.querySelector(`[data-banner-video="${device}"]`).content.firstElementChild.cloneNode(true);
            this.device = device;
            this.video = video;
            video.muted = true;
            video.removeAttribute('poster');
            video.querySelectorAll('img').forEach(image => image.remove());
            this.media.append(video);
            video.load();
          }
          const video = this.video;
          if (video.paused) video.play().catch(() => { if (this.video === video) this.updateControl(); });
          this.updateControl();
        }
        updateControl() {
          const playing = !!this.video && !this.video.paused && !this.video.error;
          this.control.toggleAttribute('data-playing', playing);
          this.control.setAttribute('aria-label', playing ? this.control.dataset.pauseLabel : this.control.dataset.playLabel);
        }
        disconnectedCallback() {
          this.observer?.disconnect();
          this.video?.pause();
          this.video?.remove();
          this.video = null;
          if (this.control) this.control.hidden = true;
          super.disconnectedCallback();
        }
      });
    };
    if (typeof ManagedHTMLElement !== 'undefined') register();
    else document.addEventListener('DOMContentLoaded', register, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('order-faq')) {
    customElements.define('order-faq', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this.ready ||= () => this.connectedCallback();
          document.addEventListener('DOMContentLoaded', this.ready, {once:true});
          return;
        }
        this.search = this.querySelector('.order-faq__search');
        if (this.search) {
          this.input = this.search.querySelector('input');
          this.clear = this.search.querySelector('[data-faq-clear]');
          this.normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
          this.records = Array.from(this.querySelectorAll('.order-faq__item')).map(el => {
            const group = el.closest('.order-faq__group');
            const intro = group?.querySelector('.order-faq__category-intro');
            return {el, group, text: this.normalise((intro?.textContent || '') + ' ' + el.textContent)};
          });
          this.onSearch = () => {
            const terms = this.normalise(this.input.value).trim().split(/\s+/).filter(Boolean);
            if (terms.length && !this.filtering) this.records.forEach(row => row.wasOpen = row.el.open);
            let count = 0;
            this.records.forEach(row => {
              row.el.hidden = !terms.every(term => row.text.includes(term));
              if (!row.el.hidden) count++;
              if (terms.length) row.el.open = !row.el.hidden;
              else if (this.filtering) row.el.open = row.wasOpen;
            });
            this.querySelectorAll('.order-faq__group').forEach(el => el.hidden = !this.records.some(row => row.group === el && !row.el.hidden));
            this.search.querySelector('[data-faq-count]').textContent = count;
            this.search.querySelector('[data-faq-status]').hidden = !terms.length;
            this.search.querySelector('[data-faq-empty]').hidden = !terms.length || count > 0;
            this.clear.hidden = !terms.length;
            this.filtering = !!terms.length;
          };
          this.onClear = () => { this.input.value = ''; this.onSearch(); this.input.focus(); };
          this.input.addEventListener('input', this.onSearch);
          this.clear.addEventListener('click', this.onClear);
          this.onCategory = event => { if (event.target.closest('.order-faq__navigation a')) { this.input.value = ''; this.onSearch(); } };
          this.addEventListener('click', this.onCategory);
          this.onSearch();
          this.search.hidden = false;
        }
        this.onBlockSelect ||= event => {
          if (this.input) { this.input.value = ''; this.onSearch(); }
          const question = event.target.closest('.order-faq__item');
          if (question && this.contains(question)) question.open = true;
        };
        if (window.Shopify?.designMode) this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (this.ready) document.removeEventListener('DOMContentLoaded', this.ready);
        if (this.input) { this.input.value = ''; this.onSearch(); }
        this.input?.removeEventListener('input', this.onSearch);
        if (this.onCategory) this.removeEventListener('click', this.onCategory);
        this.clear?.removeEventListener('click', this.onClear);
        this.filtering = false;
        if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('footer-newsletter')) {
  customElements.define('footer-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) { this.initTimer = setTimeout(() => this.isConnected && this.connectedCallback(), 0); return; }
      this.fieldset = this.querySelector('fieldset');
      this.status = this.querySelector('[role="status"]');
      this.email = this.querySelector('input[type="email"]');
      this.onSubmit = this.submit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
      const configured = /^[a-zA-Z0-9]{6}$/.test(this.dataset.siteId) && /^[a-zA-Z0-9]{6}$/.test(this.dataset.listId);
      this.fieldset.disabled = !configured;
      if (!configured) this.status.textContent = this.hasAttribute('data-design-mode') ? 'Add a valid public Klaviyo site ID and list ID in the section settings.' : this.dataset.error;
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.request?.abort();
      clearTimeout(this.timeout);
    }
    async submit(event) {
      event.preventDefault();
      if (this.pending || !this.form.reportValidity() || this.querySelector('[data-honeypot]').value) return;
      if (this.hasAttribute('data-design-mode')) {
        this.status.textContent = 'Editor preview only. Test sign-ups from the storefront preview.';
        return;
      }
      this.pending = true;
      this.fieldset.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      const properties = {};
      if (this.dataset.offerProperty && this.dataset.offerValue) properties[this.dataset.offerProperty] = this.dataset.offerValue;
      const payload = { data: { type: 'subscription', attributes: {
        custom_source: this.dataset.source,
        profile: { data: { type: 'profile', attributes: { email: this.email.value.trim(), properties,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: this.dataset.listId } } } } };
      this.request = new AbortController();
      this.timeout = setTimeout(() => this.request.abort(), 12000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.siteId), {
          method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(payload), signal: this.request.signal
        });
        if (response.status !== 202) throw new Error('Subscription not accepted');
        if (!this.isConnected) return;
        this.status.textContent = this.dataset.success;
        this.form.reset();
      } catch {
        if (this.isConnected) this.status.textContent = this.dataset.error;
      } finally {
        clearTimeout(this.timeout);
        this.pending = false;
        this.fieldset.disabled = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!window.TFFCFooterAccordions) {
  window.TFFCFooterAccordions = true;
  const mobileFooter = window.matchMedia('(max-width: 740px)');
  const syncFooterAccordions = () => {
    document.querySelectorAll('.footer__accordion').forEach(accordion => {
      if (mobileFooter.matches) accordion.removeAttribute('open');
      else accordion.setAttribute('open', '');
    });
  };
  syncFooterAccordions();
  mobileFooter.addEventListener('change', syncFooterAccordions);
  document.addEventListener('shopify:section:load', syncFooterAccordions);
}
if (!customElements.get('footer-size-observer')) {
  customElements.define('footer-size-observer', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const height = this.parentElement.offsetHeight + 'px';
          if (document.documentElement.style.getPropertyValue('--footer-height') !== height) document.documentElement.style.setProperty('--footer-height', height);
        });
      });
      this.observer.observe(this.parentElement);
    }
    disconnectedCallback() { this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
  if (!customElements.get('gift-card-page')) {
    customElements.define('gift-card-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const status = this.querySelector('[data-copy-status]');
        if (status) status.textContent = '';
        this.querySelectorAll('[data-copy], [data-print]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', async event => {
          if (event.target.closest('[data-print]')) window.print();
          const button = event.target.closest('[data-copy]');
          if (!button) return;
          const code = this.querySelector('[data-code]');
          const status = this.querySelector('[data-copy-status]');
          status.textContent = '';
          let copied = false;
          try {
            await navigator.clipboard.writeText(code.dataset.code);
            copied = true;
          } catch {
            if (!this.isConnected) return;
            // Embedded previews and older browsers may block the Clipboard API.
            const input = document.createElement('textarea');
            input.value = code.dataset.code;
            input.readOnly = true;
            input.className = 'visually-hidden';
            input.tabIndex = -1;
            input.setAttribute('aria-labelledby', code.getAttribute('aria-labelledby'));
            this.append(input);
            try {
              input.focus({ preventScroll: true });
              input.select();
              copied = document.execCommand('copy');
            } catch {
              copied = false;
            } finally {
              input.remove();
              button.focus({ preventScroll: true });
            }
          }
          if (!this.isConnected) return;
          if (copied) {
            status.textContent = status.dataset.success;
          } else {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(code);
            selection.removeAllRanges();
            selection.addRange(range);
            code.focus();
            status.textContent = status.dataset.failure;
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.pdp-feature-cards__card');
    if (!card || !window.matchMedia('(max-width: 740px)').matches) return;
    const track = card.parentElement;
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: 'instant' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-section')) {
    customElements.define('testimonials-section', class extends HTMLElement {
      connectedCallback() {
        this.listeners?.abort();
        this.listeners = new AbortController();
        this.addEventListener('click', event => {
          const button = event.target.closest('.testimonials-slide-text-btn');
          if (!button || button.closest('testimonials-section') !== this) return;
          const text = button.closest('[data-testimonial-text]');
          const small = text?.querySelector('.testimonials-slide-text-small');
          const big = text?.querySelector('.testimonials-slide-text-big');
          if (!small || !big) return;
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          small.classList.toggle('active', expanded);
          big.classList.toggle('active', expanded);
          button.classList.toggle('active', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        }, { signal: this.listeners.signal });
      }
      disconnectedCallback() { this.listeners?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trust-bar-height')) {
    customElements.define('trust-bar-height', class extends HTMLElement {
      connectedCallback() {
        const wrapper = this.closest('.shopify-section--trust-bar');
        if (!wrapper) return;
        const measure = () => document.documentElement.style.setProperty('--trust-bar-height', wrapper.clientHeight + 'px');
        this.observer = new ResizeObserver(measure);
        this.observer.observe(wrapper);
        measure();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.documentElement?.style.setProperty('--trust-bar-height', '0px');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
